import * as React from "react";
const SvgEmptyProgress = props => <svg xmlns="http://www.w3.org/2000/svg" width={36} height={36} fill="none" viewBox="0 0 36 36" {...props}><circle cx={18} cy={18} r={16} stroke="#E0E0E0" strokeWidth={4} /></svg>;
export { SvgEmptyProgress as ReactComponent };